import { render, staticRenderFns } from "./AttributeMatching.vue?vue&type=template&id=0b68c51a&"
import script from "./AttributeMatching.vue?vue&type=script&lang=js&"
export * from "./AttributeMatching.vue?vue&type=script&lang=js&"
import style0 from "./attribute-matching.scss?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports